module.exports = __webpack_public_path__ + "static/media/16_crisalide.8dfb3369.jpg";